var map = {
	"./account.svg": 64242,
	"./accounts.svg": 10372,
	"./adduser.svg": 11194,
	"./apps.svg": 81257,
	"./back.svg": 84388,
	"./basedata.svg": 13204,
	"./baterry.svg": 23875,
	"./baterryinfo.svg": 56173,
	"./branch.svg": 90137,
	"./chart.svg": 79048,
	"./code.svg": 45159,
	"./comment.svg": 78219,
	"./controller.svg": 90880,
	"./count.svg": 14692,
	"./createPPT.svg": 1993,
	"./dashboard.svg": 43920,
	"./detailelist.svg": 44119,
	"./dict.svg": 15347,
	"./dicttype.svg": 71663,
	"./dim.svg": 64427,
	"./dlbox.svg": 69528,
	"./docs.svg": 29990,
	"./drag.svg": 90859,
	"./element-plus-logo.svg": 22228,
	"./evaluate.svg": 12956,
	"./example.svg": 16905,
	"./eye-open.svg": 53240,
	"./eye.svg": 63644,
	"./fill.svg": 71675,
	"./form.svg": 36611,
	"./home.svg": 47744,
	"./language.svg": 11334,
	"./lingdang.svg": 56858,
	"./link.svg": 14637,
	"./logs.svg": 38870,
	"./menu.svg": 3791,
	"./nested.svg": 6719,
	"./no.svg": 30309,
	"./other.svg": 56700,
	"./partner.svg": 46310,
	"./password.svg": 95712,
	"./permission.svg": 48754,
	"./phone.svg": 74538,
	"./poll.svg": 84136,
	"./ppt.svg": 9017,
	"./qrcode.svg": 94557,
	"./qy.svg": 8461,
	"./rar.svg": 23860,
	"./right.svg": 23756,
	"./role.svg": 75973,
	"./send.svg": 91477,
	"./setting.svg": 25530,
	"./stack.svg": 14003,
	"./staff.svg": 65773,
	"./supplier.svg": 82136,
	"./system.svg": 33041,
	"./table.svg": 27224,
	"./tags.svg": 10100,
	"./tempGroup.svg": 83397,
	"./tooltip.svg": 25560,
	"./tree.svg": 38389,
	"./upload.svg": 22483,
	"./user.svg": 55159,
	"./userlist.svg": 64965,
	"./usermsg.svg": 29115,
	"./users.svg": 45874,
	"./usersmsg.svg": 5052,
	"./validimg.svg": 31053,
	"./wa.svg": 38325,
	"./xwtd.svg": 36447,
	"./yes.svg": 84375,
	"./zb.svg": 54335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;